<template>
    <b-container fluid>
      <h5><strong>Générer les points de la carte</strong></h5>
      <b-row class="justify-content-md-center">
        <b-col col lg="1">
        </b-col>
        <b-col cols="12" md="auto" >
          <p>Liste des points à renseigner</p>
          <b-form-group v-if="tempInventries.length === 0" class="text-left">
              <b-form-checkbox v-for="referencePoint in referencePoints" v-bind:key="referencePoint.id" 
                               v-model="selectedReferencePoint" :value="referencePoint.id">
                    <div v-if="referencePoint.xViewport != null" class="refPointOK"> {{referencePoint.label + " - OK"}} </div>
                    <div v-if="referencePoint.xViewport === null"> {{referencePoint.label}} </div>
              </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col  col lg="1">
        </b-col>
      </b-row>
      <p v-if="tempInventries.length === 0">Renseignez le point n° {{selectedReferencePoint}} en double cliquant sur sa position dans la carte </p>
      <b-row class="bottom-row">
          <b-col>
            <b-button v-if="tempInventries.length === 0" :disabled="!checkStatus()" variant="info" @click="generateInventries()">Générer</b-button>
            <b-button v-if="tempInventries.length !== 0" variant="warning" @click="resetTempInventries()">Resaisir</b-button>
            <b-button v-if="tempInventries.length !== 0" variant="success" @click="addGenerateInventries()">Enregistrer</b-button>
            <b-button variant="danger" @click="cancelInventryGenerator()">Annuler</b-button>
          </b-col>
      </b-row>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@components/bus/bus.js';

export default {
  name: 'InventryGenerator',
  computed: {
    ...mapGetters({
      getSelectedReferencePoint: 'getSelectedReferencePoint',
      referencePoints: 'getReferencePoints',
      tempInventries: 'getTempInventries',
      currentMap: 'getCurrentMap'
    })
  },
  data(){
    return {
      selectedReferencePoint: null,
    }
  },
  created(){ this.selectedReferencePoint = this.getSelectedReferencePoint },
  watch:{
    getSelectedReferencePoint() { this.selectedReferencePoint = this.getSelectedReferencePoint },
    selectedReferencePoint(){ this.$store.commit('SET_SELECTED_REFERENCE_POINT', this.selectedReferencePoint) }
  },
  methods: {
  // Méthode permettant de savoir si tous les PE de référence ont bien des coordonnées 
  // débloque le bouton de génération des entrées d'inventaire si true
    checkStatus: function() {
      let status = true
      for(let i=0; i < this.referencePoints.length; i ++) {
        if(this.referencePoints[i].xViewport === null) {
          status = false
        } 
      }
      return status
    },
    // Appel de la fonction permettant de générer les entrées d'inventaires dans le store
    generateInventries: function() {
      this.$store.dispatch('generateInventries')
    },
    // Ajoute les entrées d'inventaires temporaires au graphe
    addGenerateInventries: function(){
      this.$store.dispatch('addGenerateInventries')
      this.cancelInventryGenerator()
    },    
    // Ferme le bandeau et restaure les valeurs par défaut
    cancelInventryGenerator: function(){
      EventBus.$emit('showOrHideInventryGeneratorSideBar')
      this.resetTempInventries()
    },
    // Restaure les valeurs par défaut
    resetTempInventries: function() {
      this.$store.dispatch('resetInventryGenerator')
      this.selectedReferencePoint = this.getSelectedReferencePoint
    }
  }

}
</script>
<style>
.refPointOK {
  color: rgb(27, 160, 27);
  font-weight: bold;
}
.bottom-row {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarInventryGenerator/InventryGenerator.vue